<template>
  <div>
    <div>
      <b-button class="akkurate-green-btn me-2" @click="add_or_edit = 'add'; $bvModal.show('roles-modal')">
        <span><font-awesome-icon :icon="['fas', 'plus']" /></span>
      </b-button>
      <b-button :disabled="disable_edit" class="akkurate-green-btn" @click="openEditModal()">
        <span><font-awesome-icon :icon="['fas', 'edit']" /></span>
      </b-button>
      <!-- Modal code here -->
    </div>

    <b-modal id="roles-modal" ref="modal" @ok="handleOk" @hidden="resetModal">
      <template #modal-title>
        <h6 class="akkurate-green fw-bold mb-0">{{ add_or_edit == 'add' ? 'Add Roles' : 'Edit Roles' }}</h6>
      </template>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group class="mb-2"  label-for="name-input" invalid-feedback="Name is required" :state="nameState">
          <template #label>
            <label class="akkurate-dark small">Name <star></star></label>
          </template>
          <b-form-input id="name-input" :disabled="add_or_edit == 'edit'" class="mt-1 field-container fields"
            v-model="form.display_name" required>
          </b-form-input>
        </b-form-group>
        <b-form-group class="mb-2"  label-for="name-input" invalid-feedback="Withdraw max thershold is required"
          :state="unapproved_withdrawal_max_amountState">
          <template #label>
            <label class="akkurate-dark small">Withdrawal Max Threshold <star></star></label>
          </template>
          <b-form-input id="name-input" class="mt-1 field-container fields"
            v-model="form.unapproved_withdrawal_max_amount">
          </b-form-input>

          <errors v-if="form.errors?.first_name">
            {{ form.errors?.first_name[0] }}
          </errors>
        </b-form-group>
        <b-form-group class="mb-2"  label-for="name-input" invalid-feedback="Withdraw max thershold is required"
          :state="unapproved_withdrawal_max_amountState">
          <template #label>
            <label class="akkurate-dark small">Restricted Products </label>
          </template>
          <multiselect class="mt-1 field-container" :multiple="true" :close-on-select="false"
            :clear-on-select="false" v-model="form.unaccess_product" :custom-label="ProductLabel" track-by="id"
            :options="products_options" placeholder="Select one" selectLabel="" deselectLabel="">
             <template slot="selection">
              <span class="multiselect__single" v-if="form.unaccess_product.length">{{ form.unaccess_product.length }} options
                selected</span>
            </template>
          </multiselect>
           <div class="akkurate-small">{{ getProduct }}</div>

          <errors v-if="form.errors?.unaccess_product">
            {{ form.errors?.unaccess_product[0] }}
          </errors>
        </b-form-group>
        <b-form-group class="mb-2"  label-for="name-input" invalid-feedback="Withdraw max thershold is required"
          :state="unapproved_withdrawal_max_amountState">
          <template #label>
            <label class="akkurate-dark small">Permitted Chart of Account </label>
          </template>
          <multiselect class="mt-1 field-container" :multiple="true" :close-on-select="false"
            :clear-on-select="false" v-model="form.unaccess_coa" :custom-label="CoaLabel" track-by="id"
            :options="coa_options" placeholder="Select one" selectLabel="" deselectLabel="">
            <template slot="selection">
              <span class="multiselect__single" v-if="form.unaccess_coa.length">{{ form.unaccess_coa.length }} options
                selected</span>
            </template>
          </multiselect>
          <div class="akkurate-small">{{ getCoa }}</div>

          <errors v-if="form.errors?.unaccess_coa">
            {{ form.errors?.unaccess_coa[0] }}
          </errors>
        </b-form-group>
      </form>
      <template #modal-footer="{ ok }">
        <div class="w-100">
          <b-button @click="ok()" type="submit" class="akkurate-green-btn btn-size me-2 float-right"><font-awesome-icon
              class="me-2" :icon="['fas', 'save']" />Save</b-button>
          <b-button @click="$bvModal.hide('roles-modal')" type="button"
            class="akkurate-grey-btn btn-size border-0 me-2 float-right"><font-awesome-icon class="me-2"
              :icon="['fas', 'close']" />Close</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  name: "RolesModal",
  props: ['selected_role', 'disable_edit', 'products_options', 'coa_options'],
  components: {
    Multiselect
  },
  // selected_role: {
  //   handler(newVal) {
  //     console.log("Here");
  //     // Disable edit button if selected_role is empty, otherwise enable it
  //     this.disable_edit = !newVal || Object.keys(newVal).length === 0;
  //   },
  //   immediate: true, // Trigger the handler immediately on component creation
  //   deep: true // Watch for nested changes in selected_role
  // },
  data() {
    return {
      form: {
        id: "",
        display_name: "",
        unapproved_withdrawal_max_amount: "",
        unaccess_product: [],
        unaccess_coa: [],
      },
      unapproved_withdrawal_max_amountState: null,
      nameState: null,
      errors: [],
      add_or_edit: "add",
    }
  },
  computed: {
    getProduct() {
      if (this.form.unaccess_product.length > 0) {
        const result = this.form.unaccess_product.map((index) => {
          return `${index.name}`;
        });
        // console.log("here");
        return result.join(" | "); // Join array elements with ", "
      } else {
        return "";
      }

    },
    getCoa() {
      if (this.form.unaccess_coa.length > 0) {
        const result = this.form.unaccess_coa.map((index) => {
          return `${index.code} - ${index.name} (${index.coabranch.name})`;
        });
        // console.log("here");
        return result.join(" | "); // Join array elements with ", "
      } else {
        return "";
      }

    },
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      this.unapproved_withdrawal_max_amountState = valid;
      return valid
    },
    resetModal() {
      this.form.display_name = '';
      this.form.unapproved_withdrawal_max_amount = "";
      this.form.unaccess_coa = [];
      this.form.unaccess_product = [];
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      if (this.add_or_edit == 'add') {
        this.$emit('saveRole', this.form);
      } else {
        this.form.unaccess_coa = this.form.unaccess_coa.map(index => index.id);
        this.form.unaccess_product = this.form.unaccess_product.map(index => index.id);
        this.$emit('editRole', this.form);
      }

      this.$emit('resetForm', this.resetModal())
      this.resetModal();
      // Hide the modal manually
      this.$nextTick(() => {
        // this.$bvModal.hide("roles-modal");
      });
    },
    openEditModal() {
      // console.log(this.selected_role);
      this.add_or_edit = 'edit';
      this.form.id = this.selected_role.id; // Populate form with role data
      this.form.display_name = this.selected_role.display_name; // Populate form with role data
      this.form.unapproved_withdrawal_max_amount = this.selected_role.unapproved_withdrawal_max_amount; // Populate form with role data
      // console.log(this.form);
      this.$bvModal.show('roles-modal');
    },
    ProductLabel({ id, name }) {
      return `${name}`
    },
    CoaLabel({ code, name, coabranch }) {
      return `${code} - ${name} (${coabranch.name})`
    },

  }
};
</script>